import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledEnrollmentFlow = styled.div`
  min-height: 100vh;

  .ant-layout {
    min-height: 100vh;
    background: ${Colors.secondBackground};

    .ant-layout-content {
      display: flex;
      justify-content: center;
      align-items: center;

      .ant-spin-nested-loading,
      .ant-spin-container {
        height: 100%;
      }

      .flow-card {
        //width: 400px;

        .title-image {
          width: 200px;
          margin: 0 auto;
        }

        .teacher-name {
          color: ${Colors.purple};
        }
        .class-name {
          color: ${Colors.greenishBlue};
        }

        .centered-form {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .ant-form {
            width: 100%;
          }
        }
      }
    }
  }
`;
